import Router from 'next/router'

const navigateToPage: typeof Router.push = (page, route, options) => Router.push(page, route, options)

export default navigateToPage
